import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { akitaConfig, enableAkitaProdMode } from '@datorama/akita';
import { enableElfProdMode } from '@ngneat/elf';
import { IS_PROD_BUILD } from '@y42/environment';
import { LicenseManager } from 'ag-grid-enterprise';
import { AppModule } from './app/app.module';

if (IS_PROD_BUILD) {
  enableProdMode();
  enableAkitaProdMode();
  enableElfProdMode();
}

akitaConfig({ resettable: true });

LicenseManager.setLicenseKey(
  'CompanyName=Datos-Intelligence GmbH,LicensedApplication=Datos,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=1,AssetReference=AG-026970,ExpiryDate=15_May_2023_[v2]_MTY4NDEwNTIwMDAwMA==16880adeaae7008eb4e97ef84502e8cd',
);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
